import React, { useEffect, useState, useCallback } from "react";
import { AIRTABLE_URL, AIRTABLE_HEADERS } from "./constants";

export default function MyBooking() {
  const [history, setHistory] = useState([]);
  const userPhone = localStorage.getItem("userPhone");

  // Load local booking history
  useEffect(() => {
    const local = localStorage.getItem("bookingHistory");
    if (local) {
      setHistory(JSON.parse(local));
    }
  }, []);

  // ✅ Wrap fetchLatestUpdates with useCallback to fix exhaustive-deps warning
  const fetchLatestUpdates = useCallback(async () => {
    try {
      const res = await fetch(
        `${AIRTABLE_URL}?filterByFormula=AND({phone}='${userPhone}', OR({paid} = '', {paid} = FALSE()))`,
        { headers: AIRTABLE_HEADERS }
      );
      const result = await res.json();

      const data = result.records.map((record) => {
        const fields = record.fields;
        return {
          ...fields,
          id: record.id,
          approved: fields.status === "approved",
          cancelled: fields.cancelled?.toString().toLowerCase() === "true",
          workCompleted: fields.workCompleted?.toString().toLowerCase() === "true",
          paid: fields.paid?.toString().toLowerCase() === "true",
          technicianAssigned: !!fields.assignedTechnicianPhone?.trim(),
          assignedTechnicianPhone: fields.assignedTechnicianPhone || "",
          updatedServices: fields.extraParts || "",
          updatedTotal: fields.total || fields.totalPrice,
        };
      });

      localStorage.setItem("bookingHistory", JSON.stringify(data));
      setHistory(data);
    } catch (err) {
      console.error("Polling error:", err);
    }
  }, [userPhone]);

  // Polling for latest updates
  useEffect(() => {
    fetchLatestUpdates();
    const interval = setInterval(fetchLatestUpdates, 8000);
    return () => clearInterval(interval);
  }, [fetchLatestUpdates]);
  
  const getRecordIdByOrderId = async (orderId) => {
    try {
      const res = await fetch(
        `${AIRTABLE_URL}?filterByFormula={orderId}="${orderId}"`,
        { headers: AIRTABLE_HEADERS }
      );
      const result = await res.json();
      return result.records[0]?.id || null;
    } catch (err) {
      console.error("Error fetching record ID:", err);
      return null;
    }
  };

 const handleApprove = async (booking) => {
  const recordId = await getRecordIdByOrderId(booking.orderId);
  if (!recordId) return;

  await fetch(`${AIRTABLE_URL}/${recordId}`, {
    method: "PATCH",
    headers: AIRTABLE_HEADERS,
    body: JSON.stringify({ fields: { status: "approved" } }),
  });

  const local = JSON.parse(localStorage.getItem("bookingHistory")) || [];
  const updated = local.map(item =>
    item.orderId === booking.orderId ? { ...item, approved: true } : item
  );
  localStorage.setItem("bookingHistory", JSON.stringify(updated));
  setHistory(updated);
};


 const handleCancelApprove = async (booking) => {
  const recordId = await getRecordIdByOrderId(booking.orderId);
  if (!recordId) return;

  await fetch(`${AIRTABLE_URL}/${recordId}`, {
    method: "PATCH",
    headers: AIRTABLE_HEADERS,
    body: JSON.stringify({ fields: { cancelled: "TRUE", status: "cancelled" } }),
  });

  const local = JSON.parse(localStorage.getItem("bookingHistory")) || [];
  const updated = local.map(item =>
    item.orderId === booking.orderId
      ? { ...item, cancelled: true, status: "cancelled" }
      : item
  );
  localStorage.setItem("bookingHistory", JSON.stringify(updated));
  setHistory(updated);
};

  const isPaid = (val) => val === true || val === "TRUE" || val === "true";
  const activeBookings = history.filter((b) => !isPaid(b.paid));

  return (
    <div style={{ padding: "40px 0px" }}>
      <h2>My Bookings</h2>
      {activeBookings.length === 0 ? (
        <p>No active bookings.</p>
      ) : (
        <ul style={{ listStyle: "none", padding: 0 }}>
          {activeBookings.map((booking, index) => {
const serviceLine = Array.isArray(booking.services) ? booking.services.join(", ") : booking.services;
let serviceTotal = 0;

if (serviceLine) {
  const serviceItems = serviceLine.split(","); // alag alag services
  serviceItems.forEach(item => {
    const priceMatch = item.match(/₹\s?(\d+)/);
    const qtyMatch = item.match(/x\s?(\d+)/);

    const price = priceMatch ? parseInt(priceMatch[1], 10) : 0;
    const qty = qtyMatch ? parseInt(qtyMatch[1], 10) : 1;

    serviceTotal += price * qty;
  });
}
const extraPartsCost = booking.updatedServices
  ? booking.updatedServices.split(",").reduce((total, part) => {
      const match = part.match(/₹\s?(\d+)/);
      return total + (match ? parseInt(match[1], 10) : 0);
    }, 0)
  : 0;

const grandTotal = booking.approved
  ? serviceTotal + extraPartsCost
  : serviceTotal;



            return (
              <li
                key={`${booking.orderId}-${index}`}
                style={{
                  border: "1px solid #ccc",
                  padding: 10,
                  marginBottom: 10,
                  borderRadius: 6,
                  background: "#f9f9f9",
                }}
              >
                {booking.technicianAssigned ? (
                  <p style={{ color: "#2e86de", fontSize: "12px" }}>
                    Technician assigned: <b>{booking.assignedTechnicianPhone}</b>
                  </p>
                ) : (
                  <p style={{ fontSize: "12px", color: "#999" }}>
                    Searching for technician...
                  </p>
                )}

                <p><b>Order ID:</b> {booking.orderId}</p>
                <p><b>Name:</b> {booking.name}</p>
                {/* ✅ Only original services here */}
                <p><b>Services:</b> { booking.servicesFormatted 
                ?? (Array.isArray(booking.services) ? booking.services.join(", ") : booking.services || "N/A") }</p>
                <p><b>Service Total:</b> ₹{serviceTotal}</p>
                <p><b>Slot:</b> {booking.slot}</p>


                {booking.updatedServices && !booking.cancelled && (
                  <div style={{ background: "#f1f1f1", padding: 10, marginTop: 10, borderRadius: 6 }}>
                    <p><b>Technician has listed additional parts. Please approve if you're okay with the changes</b></p>
                    <p><b>Extra Parts:</b> {booking.updatedServices}</p>
                    <p><b>Extra Parts Total:</b> ₹{extraPartsCost}</p>
                    <p><b>Grand Total:</b> ₹{grandTotal}</p>

                    {!booking.approved && (
                      <div>
                        <button
                          onClick={() => handleApprove(booking)}
                          style={{ marginRight: 10, background: "green", color: "#fff", padding: "5px 10px", borderRadius: 4 }}
                        >
                          Approve
                        </button>
                        <button
                          onClick={() => handleCancelApprove(booking)}
                          style={{ background: "red", color: "#fff", padding: "5px 10px", borderRadius: 4 }}
                        >
                          Reject
                        </button>
                      </div>
                    )}
                  </div>
                )}

                {booking.approved && <p style={{ color: "green" }}>✔️ Extra parts approved</p>}
                {booking.cancelled && !booking.approved && <p style={{ color: "red" }}>❌ You have Rejected extra parts</p>}

                {booking.workCompleted && !booking.paid && (
                  <div style={{ marginTop: 10 }}>
                    <p style={{ color: "green" }}>✅ Work Completed</p>
                    <p style={{ fontWeight: "bold", color: "#c0392b" }}>
                      Technician has done his work. Please make the payment.
                    </p>
                    <a
                      href={`upi://pay?pa=mohdfaizan8222-1@okhdfcbank&pn=Service%20Provider&am=${grandTotal}&cu=INR&tn=Service%20Payment%20for%20Order%20${booking.orderId}`}
                      style={{ display: "inline-block", background: "#007bff", color: "#fff", padding: "8px 12px", borderRadius: 6, textDecoration: "none", marginTop: 6 }}
                    >
                      Pay ₹{grandTotal} via UPI 💳
                    </a>
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
